/**
 * Returns the first element that matches the specified CSS selector.
 * @param {string} s - The CSS selector to match.
 * @param {Document|Element} [o=document] - The document or element to search in.
 * @returns {Element|null} - The first matching element, or null if no element matches the selector.
 */
export const qs = (s, o = document) => o.querySelector(s)

/**
 * Returns a list of elements that match the specified CSS selector.
 * @param {string} s - The CSS selector to match.
 * @param {Document|Element} [o=document] - The document or element to search in.
 * @returns {NodeList} - A list of matching elements.
 */
export const qsa = (s, o = document) => o.querySelectorAll(s)
